module.exports = __webpack_public_path__ + "media/images/hodzzy-desc-1-f512b24996e4d9f66ee88fe7488e113f.png";